import React from 'react'
import { EnduroFundersDashboard } from './components/EnduroFundersDashboard'

const EnduroFundersApp: React.FC = () => {
  return <EnduroFundersDashboard />
}

export default EnduroFundersApp